import React, { useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { parse } from 'query-string';
import omit from 'lodash/omit';
import Layout from '../../../../components/Layout/Layout';
import Card from '../../../../components/Card/Card';
import TicketsList from '../../components/Tickets/TicketsList';
import Pagination from '../../../../components/Pagination/Pagination';
import { TicketForm } from '../../../../components/Tickets/TicketForm';
import WithAlert from '../../../../hoc/WithAlert';
import { startCreateTicket } from '../../../../actions/tickets';
import { startSetProfile } from '../../../../actions/webmaster';
import { startSetOffer, resetOffer } from '../../../../actions/offers';


const TicketsPage = ({
  data: { loading, page, tickets, pageCount },
  cardHeaderRef,
  changePage,
  history, startSetProfile, startCreateTicket, showAlert, intl,
  location,
  offer
}) => {
  const [theme, setTheme] = useState(parse(location.search).theme)

  const getTheme = () => {
    const theme = parse(location.search).theme;
    return theme;
  };

  const submit = data => {

    let message = '';

    const theme = getTheme();
    const formData = new FormData();

    const params = theme === 'masterAccount' ?
      { ...data, masterAccount: 1 }
      :
      omit(data, 'masterAccount');

    Object.keys(params).forEach(paramName => {
      if (Array.isArray(params[paramName])) {
        for (let i in params[paramName]) {
          formData.append([paramName], params[paramName][i]);
        }
      } else {
        formData.append([paramName], params[paramName]);
      }
    });

    const postRequestActions = theme === 'masterAccount' ?
      () => startSetProfile().finally(() => history.push('/tools/master'))
      :
      () => history.push('/tickets');

    startCreateTicket(formData)
      .then(postRequestActions)
      .catch(({ response = {} }) => {
        if (response.data && response.data.error) {
          const { message: error } = response.data.error;
          message = error.message;
        } else {
          message = iFMessage({ intl, id: 'main.error' });
        }
        showAlert({
          message,
          alertType: 'danger',
          closeInSeconds: 5,
        });
        return message;
      });
  };


  return (
    <Layout className='tickets-page' formattedTitle="pages.tickets.title">
      <Layout.LeftCol>
        <Card
          loading={loading}
        >
          <Card.Body className="no-padding">
            {tickets.length > 0 ? (
              <TicketsList total={pageCount} tickets={tickets} />
            ) : (
                <div className="card-empty">
                  <FormattedMessage id="tickets.no_tickets" defaultMessage="No Tickets" />
                </div>
              )}
          </Card.Body>
          {pageCount > 1 && (
            <Card.Footer>
              <Pagination
                pageCount={pageCount}
                onPageChange={changePage}
                activePage={page + 1}
                scrollToAfterPageChanged={{
                  ref: cardHeaderRef,
                }}
              />
            </Card.Footer>
          )}
        </Card>
      </Layout.LeftCol>
      <Layout.RightCol>
        <Card>
          <Card.Header className='header-with-subtitle' titleLG={true}>
            <FormattedMessage id="tickets.create_ticket" defaultMessage="Create Ticket" />
            <Link to="/faq/">
              <p className="header-subtitle">
                (
                <FormattedMessage
                  id="tickets.perhaps_answer.theme_4"
                  defaultMessage="Perhaps the answer to your question is already in the"
                />
                &nbsp;
                <FormattedMessage id="tickets.link_help_section" defaultMessage="help section" />)
              </p>
            </Link>
          </Card.Header>
          <Card.Body>
            <TicketForm intl={intl} offer={offer} theme={theme} submit={submit} history={history} />
          </Card.Body>

        </Card>
      </Layout.RightCol>
    </Layout>
  );
};

const mapStateToProps = ({ offers }) => ({
  offer: offers.selected,
});

const mapDispatchToProps = dispatch => ({
  startCreateTicket: ticketData => dispatch(startCreateTicket(ticketData)),
  startSetOffer: offerId => dispatch(startSetOffer(offerId)),
  resetOffer: () => dispatch(resetOffer()),
  startSetProfile: () => dispatch(startSetProfile()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WithAlert(injectIntl(withRouter(TicketsPage))));
